import { render } from "./PenyusunanDokumenPemilihan.vue?vue&type=template&id=6b0728cc"
import script from "./PenyusunanDokumenPemilihan.vue?vue&type=script&lang=js"
export * from "./PenyusunanDokumenPemilihan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__